<template lang="pug">
	span.time(
		:class="{'is-overtime': time.isOvertime}"
	)
		span.minutes {{ !time.isOvertime && time.seconds >= 0 ? time.minutes + 1: time.minutes }}
		span.overtime(v-if="time.isOvertime") +{{ time.seconds >= 0 ? time.overtimeMinutes + 1 : this.overtimeMinutes }}
		span.minute-indicator '
</template>

<script>
export default {
	props: {
		time: Object
	}
}
</script>

<style lang="scss" scoped>
	.time {
		.overtime {
			color: $secondary;
			padding-left: 4px;
		}
		&.is-overtime {
			.minute-indicator {
				color: $secondary;
			}
		}
	}
</style>
